export default "__VITE_ASSET__b2171fa4__"